import { Text, View } from '@react-pdf/renderer';

// Utils
import { isEmptyValueArray } from '@shared/utils';

// Tokens
import theme, { SECTION_TITLES } from '@/components/template/resume/AgilityIO/tokens';

// Types
import { FormSkill } from '@shared/types';

// Styles
import styles from '../style';
interface TechnicalSkillsSectionProps {
  filteredSkills: FormSkill[];
}
const TechnicalSkillsSection = ({
  filteredSkills
}: TechnicalSkillsSectionProps) => {
  if (isEmptyValueArray(filteredSkills)) return null;
  return <View style={styles.section} data-sentry-element="View" data-sentry-component="TechnicalSkillsSection" data-sentry-source-file="TechnicalSkills.tsx">
      <Text style={[styles.sectionHeading, {
      marginBottom: theme.spacing.sectionHeadingGap
    }]} data-sentry-element="Text" data-sentry-source-file="TechnicalSkills.tsx">
        {SECTION_TITLES.technicalSkills}
      </Text>

      {filteredSkills.map(({
      name: categoryName = '',
      items = []
    }, idx) => {
      const skillText = items.filter(Boolean).join(', ');
      return <View key={`skill-${idx}-${categoryName}`} style={styles.listRow}>
            <View style={styles.listDot} />
            <Text style={styles.skillText}>
              <Text style={styles.skillCategory}>{categoryName}</Text>
              {categoryName && skillText ? ': ' : ''}
              {skillText}
            </Text>
          </View>;
    })}
    </View>;
};
export default TechnicalSkillsSection;